// extracted by mini-css-extract-plugin
export default {"summaryTextfield":"ReadOnlyNumberInput_summaryTextfield__bGuPg","disabled":"ReadOnlyNumberInput_disabled__s0skW"};